import { Components, Theme } from '@mui/material'

const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily: theme.fonts.family.PlusJakartaSans,
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '18px',
      color: theme.typographyColors.typographyThree,
      marginTop: '10px',
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,

      '&.Mui-error': {
        color: theme.colors.red,
      },
    }),
  },
}

export default MuiFormHelperText
